module.exports = __webpack_public_path__ + "img/aliPay.5ffba099.png";